import { Routes } from '@angular/router'
import { HomeMarketingDeskComponent } from './home-marketing-desk/home-marketing-desk.component'
import { RegisterSrecComponent } from './register-srec/register-srec.component'
import { RegisterSrecCommercialComponent } from './register-srec-commercial/register-srec-commercial.component'
import { SRECSuccessComponent } from './success-marketing-desk/success-marketing-desk.component'

export const routes: Routes = [
    { path: '', component: HomeMarketingDeskComponent },
    { path: 'register', component: RegisterSrecComponent },
    { path: 'register/commercial', component: RegisterSrecCommercialComponent },
    { path: 'success-marketing-desk', component: SRECSuccessComponent }
]
